/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
// import Dropdown from "react-bootstrap/Dropdown";
import { toast } from "react-toastify";
// import { Button } from "react-bootstrap";
// import { ChevronDown, ChevronUp } from "react-feather";
import useFetcher from "../../../hooks/useFetcher";
import { BlurSpinner } from "../../BlurSpinner";
import { getLabCategories, updateCourse, getClientGroups, getSectorGroups, getAssociatedGroups } from "../../../services/labServices";
import { CategoryLabel, CategoryText, CategoryTitle, TextError } from "./styles";
import { LabSelect } from "../select";
import { getTipo } from "../../../pages/BackOfficeLab";
import { handleErrors } from "../../../services/handleErrors";

export default function Categories({ course, readOnly, preview }) {
  const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);
  const [categories, isLoadingCategories] = useFetcher(getLabCategories, undefined);
  const [audienceValue, setAudienceValue] = useState(null);
  const [caracterValue, setCaracterValue] = useState(null);
  const [categoriesValue, setCategoriesValue] = useState(null);
  const [levelValue, setLevelValue] = useState(null);
  const [clientGroups, isLoadingClientGroups] = useFetcher(getClientGroups, undefined);
  const [sectorGroups, isLoadingSectorGroups] = useFetcher(getSectorGroups, undefined);
  const [sectorGroupValue, setSectorGroupValue] = useState(null);
  const [clientGroupValue, setClientGroupValue] = useState(null);
  const [associatedGroups, isLoadingAssociatedGroups] = useFetcher(getAssociatedGroups, undefined);
  const [asociadosValue, setAsociadosValue] = useState(null);
  // const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // const [isCancel, setIsCancel] = useState(false);

  useEffect(() => {
    setIsLoadingUpdate(true);
    if (course && categories && !isLoadingCategories && !isLoadingClientGroups && !isLoadingSectorGroups) {
      const currentAudience = course.audience;
      setAudienceValue(currentAudience ? { label: currentAudience, value: currentAudience } : null);

      const currentCategories = categories && categories.audience && categories.categories.find((category) => category.id === course.category);
      setCategoriesValue(currentCategories ? { label: currentCategories.category, value: currentCategories.id } : null);

      const currentLevel = categories && categories.levels && categories.levels.find((level) => level.id === course.level);
      setLevelValue(currentLevel ? { label: currentLevel.level, value: currentLevel.id } : null);

      const currentCaracter = course.enrollment_requirement;
      setCaracterValue(currentCaracter ? { label: getTipo(currentCaracter, categories.enrollment_requirement), value: currentCaracter } : null);

      const currentClientGroup = clientGroups && clientGroups.find((group) => group.id === course.cliente);
      setClientGroupValue(currentClientGroup ? { label: currentClientGroup.name, value: currentClientGroup.id } : null);

      const currentSectorGroup = sectorGroups && sectorGroups.find((group) => group.id === course.sector);
      setSectorGroupValue(currentSectorGroup ? { label: currentSectorGroup.name, value: currentSectorGroup.id } : null);

      const currentAsociados = associatedGroups && associatedGroups.find((group) => group.id === course.asociadosList);
      setAsociadosValue(currentAsociados ? { label: currentAsociados.name, value: currentAsociados.id } : null);
    }
    setIsLoadingUpdate(false);
  }, [course, categories, isLoadingCategories, isLoadingClientGroups, isLoadingSectorGroups]);

  const audienceOptions = categories.audience
    ? categories.audience
        .map((categoria) => {
          return { label: categoria.text, value: categoria.text };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const caracterOptions = categories.enrollment_requirement
    ? categories.enrollment_requirement
        .map((categoria) => {
          return { label: getTipo(categoria.text, categories.enrollment_requirement), value: categoria.text };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const categoriesOptions = categories.categories
    ? categories.categories
        .map((categoria) => {
          return { label: categoria.category, value: categoria.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const levelOptions = categories.levels
    ? categories.levels
        .map((level) => {
          return { label: level.level, value: level.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const clientGroupOptions =
    clientGroups && clientGroups.length > 0
      ? clientGroups
          .map((group) => {
            return { label: group.name, value: group.id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
          .concat({ label: "Todos", value: null })
      : [];

  const sectorGroupOptions =
    sectorGroups && sectorGroups.length > 0
      ? sectorGroups
          .map((group) => {
            return { label: group.name, value: group.id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
          .concat({ label: "Todos", value: null })
      : [];

  const associatedGroupOptions =
    associatedGroups && associatedGroups.length > 0
      ? associatedGroups
          .map((group) => {
            return { label: group.name, value: group.id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
          .concat({ label: "Todos", value: null })
      : [];

  async function getFunctionToFilter(filter, selected) {
    if (!course.id) {
      toast.warning("Debe crear el curso agregando un título y descripción antes de configurar las categorías");
      return;
    }
    if (filter === "audience") {
      setAudienceValue(selected);
      try {
        const { message } = await updateCourse(course.id, { audience: selected.value });
        toast.success(message);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }
    if (filter === "caracter") {
      setCaracterValue(selected);
      try {
        const { message } = await updateCourse(course.id, { enrollment_requirement: selected.value });
        toast.success(message);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }
    if (filter === "categories") {
      setCategoriesValue(selected);
      try {
        const { message } = await updateCourse(course.id, { category: selected.value });
        toast.success(message);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }
    if (filter === "level") {
      setLevelValue(selected);
      try {
        const { message } = await updateCourse(course.id, { level: selected.value });
        toast.success(message);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }

    if (filter === "cliente") {
      setClientGroupValue(selected);
      try {
        const { message } = await updateCourse(course.id, { cliente: selected.value });
        toast.success(message);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }

    if (filter === "sector") {
      setSectorGroupValue(selected);
      try {
        const { message } = await updateCourse(course.id, { sector: selected.value });
        toast.success(message);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }

    if (filter === "asociados") {
      setAsociadosValue(selected);
      try {
        const { message } = await updateCourse(course.id, { asociadosList: selected.value });
        toast.success(message);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }
  }

  const handleReactSelectChange = async (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  return (
    <>
      <BlurSpinner isLoading={isLoadingCategories || isLoadingUpdate}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="conteiner-fluid w-100">
                        <>
                          {readOnly || preview ? (
                            <div className="container-fluid">
                              <div className="row m-3">
                                <div className="col-lg-3">
                                  <CategoryTitle style={{ borderBottom: course.audience ? "1px solid #dee2e6" : "1px solid red" }}>Público</CategoryTitle>
                                  <CategoryText>{course.audience ? course.audience : <TextError>No definido</TextError>}</CategoryText>
                                </div>
                                <div className="col-lg-3">
                                  <CategoryTitle style={{ borderBottom: course.enrollment_requirement ? "1px solid #dee2e6" : "1px solid red" }}>Caracter</CategoryTitle>
                                  <CategoryText>
                                    {course.enrollment_requirement ? (
                                      getTipo(course.enrollment_requirement, categories.enrollment_requirement)
                                    ) : (
                                      <TextError>No definido</TextError>
                                    )}
                                  </CategoryText>
                                </div>
                                <div className="col-lg-3">
                                  <CategoryTitle style={{ borderBottom: categoriesValue ? "1px solid #dee2e6" : "1px solid red" }}>Categoría</CategoryTitle>
                                  <CategoryText>{categoriesValue ? categoriesValue.label : <TextError>No definido</TextError>}</CategoryText>
                                </div>
                                <div className="col-lg-3">
                                  <CategoryTitle style={{ borderBottom: levelValue ? "1px solid #dee2e6" : "1px solid red" }}>Nivel</CategoryTitle>
                                  <CategoryText>{levelValue ? levelValue.label : <TextError>No definido</TextError>}</CategoryText>
                                </div>
                                <div className="col-lg-3">
                                  <CategoryTitle style={{ borderBottom: "1px solid #dee2e6" }}>Sector</CategoryTitle>
                                  <CategoryText>{sectorGroupValue ? sectorGroupValue.label : "Todos"}</CategoryText>
                                </div>
                                <div className="col-lg-3">
                                  <CategoryTitle style={{ borderBottom: "1px solid #dee2e6" }}>Cliente</CategoryTitle>
                                  <CategoryText>{clientGroupValue ? clientGroupValue.label : "Todos"}</CategoryText>
                                </div>
                                <div className="col-lg-3">
                                  <CategoryTitle style={{ borderBottom: "1px solid #dee2e6" }}>Asociados</CategoryTitle>
                                  <CategoryText>{asociadosValue ? asociadosValue.label : "Todos"}</CategoryText>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="container-fluid">
                              <div className="row">
                                <div className="col-lg-3">
                                  <div className="">
                                    <CategoryLabel htmlFor="audience">
                                      Público
                                      <LabSelect
                                        id="audience"
                                        name="audience"
                                        className="w-100"
                                        onChange={handleReactSelectChange}
                                        value={audienceValue}
                                        placeholder="seleccionar"
                                        // isClearable
                                        isLoading={isLoadingCategories}
                                        disabled={isLoadingCategories}
                                        options={audienceOptions}
                                      />
                                    </CategoryLabel>
                                  </div>
                                </div>
                                <div className="col-lg-3">
                                  <div className="form-group">
                                    <CategoryLabel htmlFor="caracter">
                                      Caracter
                                      <LabSelect
                                        id="caracter"
                                        name="caracter"
                                        className="w-100"
                                        onChange={handleReactSelectChange}
                                        value={caracterValue}
                                        placeholder="seleccionar"
                                        // isClearable
                                        isLoading={isLoadingCategories}
                                        isDisabled={isLoadingCategories}
                                        options={caracterOptions}
                                      />
                                    </CategoryLabel>
                                  </div>
                                </div>
                                <div className="col-lg-3">
                                  <div className="form-group">
                                    <CategoryLabel htmlFor="categories">
                                      Categoria
                                      <LabSelect
                                        id="categories"
                                        name="categories"
                                        className="w-100"
                                        onChange={handleReactSelectChange}
                                        value={categoriesValue}
                                        placeholder="seleccionar"
                                        // isClearable
                                        isLoading={isLoadingCategories}
                                        disabled={isLoadingCategories}
                                        options={categoriesOptions}
                                      />
                                    </CategoryLabel>
                                  </div>
                                </div>
                                <div className="col-lg-3">
                                  <div className="form-group">
                                    <CategoryLabel htmlFor="level">
                                      Nivel
                                      <LabSelect
                                        id="level"
                                        name="level"
                                        className="w-100"
                                        onChange={handleReactSelectChange}
                                        value={levelValue}
                                        placeholder="seleccionar"
                                        // isClearable
                                        isLoading={isLoadingCategories}
                                        disabled={isLoadingCategories}
                                        options={levelOptions}
                                      />
                                    </CategoryLabel>
                                  </div>
                                </div>
                                <div className="col-lg-3">
                                  <div className="form-group">
                                    <CategoryLabel htmlFor="sector">
                                      Sector
                                      <LabSelect
                                        id="sector"
                                        name="sector"
                                        className="w-100"
                                        onChange={handleReactSelectChange}
                                        value={sectorGroupValue}
                                        placeholder="Todos"
                                        // isClearable
                                        isLoading={isLoadingSectorGroups}
                                        disabled={isLoadingSectorGroups}
                                        options={sectorGroupOptions}
                                      />
                                    </CategoryLabel>
                                  </div>
                                </div>
                                <div className="col-lg-3">
                                  <div className="form-group">
                                    <CategoryLabel htmlFor="cliente">
                                      Cliente
                                      <LabSelect
                                        id="cliente"
                                        name="cliente"
                                        className="w-100"
                                        onChange={handleReactSelectChange}
                                        value={clientGroupValue}
                                        placeholder="Todos"
                                        // isClearable
                                        isLoading={isLoadingClientGroups}
                                        disabled={isLoadingClientGroups}
                                        options={clientGroupOptions}
                                      />
                                    </CategoryLabel>
                                  </div>
                                </div>
                                <div className="col-lg-3">
                                  <div className="form-group">
                                    <CategoryLabel htmlFor="asociados">
                                      Asociados
                                      <LabSelect
                                        id="asociados"
                                        name="asociados"
                                        className="w-100"
                                        onChange={handleReactSelectChange}
                                        value={asociadosValue}
                                        placeholder="Todos"
                                        isLoading={isLoadingAssociatedGroups}
                                        disabled={isLoadingAssociatedGroups}
                                        options={associatedGroupOptions}
                                      />
                                    </CategoryLabel>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlurSpinner>
    </>
  );
}
